import { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../../api/api";

export default function IndividualClientCreatePage() {
    const navigate = useNavigate();

    const [form, setForm] = useState({
        name: "",
        lastName: "",
        email: "",
        phoneNumber: "",
        dateOfBirth: "",
        countryId: "",
        cityId: "",
        postalCodeId: "",
        addressId: "",
    });

    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        setForm((prev) => ({
            ...prev,
            [e.target.name]: e.target.value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");

        const payload = {
            name: form.name,
            lastName: form.lastName,
            email: form.email,
            phoneNumber: form.phoneNumber,
            dateOfBirth: form.dateOfBirth || null,
            countryId: form.countryId ? Number(form.countryId) : null,
            cityId: form.cityId ? Number(form.cityId) : null,
            postalCodeId: form.postalCodeId ? Number(form.postalCodeId) : null,
            addressId: form.addressId ? Number(form.addressId) : null,
        };

        try {
            setLoading(true);
            await api.post("/Client/create", payload);
            navigate("/admin/individual-clients");
        } catch (err) {
            setError(err?.response?.data?.message || "Failed to create client.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="max-w-xl mx-auto p-6 bg-white rounded shadow">
            <h1 className="text-2xl font-bold mb-4">Create Individual Client</h1>

            {error && <p className="text-red-600 mb-3">{error}</p>}

            <form onSubmit={handleSubmit} className="space-y-3">
                <input name="name" value={form.name} onChange={handleChange} placeholder="Name" className="w-full border p-2 rounded" required />
                <input name="lastName" value={form.lastName} onChange={handleChange} placeholder="Last Name" className="w-full border p-2 rounded" required />
                <input name="email" type="email" value={form.email} onChange={handleChange} placeholder="Email" className="w-full border p-2 rounded" required />
                <input name="phoneNumber" value={form.phoneNumber} onChange={handleChange} placeholder="Phone Number" className="w-full border p-2 rounded" required />

                <input name="dateOfBirth" type="date" value={form.dateOfBirth} onChange={handleChange} className="w-full border p-2 rounded" />

                <input name="countryId" value={form.countryId} onChange={handleChange} placeholder="Country ID" className="w-full border p-2 rounded" />
                <input name="cityId" value={form.cityId} onChange={handleChange} placeholder="City ID" className="w-full border p-2 rounded" />
                <input name="postalCodeId" value={form.postalCodeId} onChange={handleChange} placeholder="Postal Code ID" className="w-full border p-2 rounded" />
                <input name="addressId" value={form.addressId} onChange={handleChange} placeholder="Address ID" className="w-full border p-2 rounded" />

                <div className="flex gap-3">
                    <button disabled={loading} className="bg-indigo-600 text-white px-4 py-2 rounded">
                        {loading ? "Creating..." : "Create"}
                    </button>

                    <button type="button" onClick={() => navigate("/admin/individual-clients")} className="border px-4 py-2 rounded">
                        Cancel
                    </button>
                </div>
            </form>
        </div>
    );
}